<template>
  <button class="print-button" @click="$emit('onClick')">Печать</button>
</template>

<script>
export default {
  name: 'PrintButton',
};
</script>

<style>
  .print-button {
    width: 130px;
    height: 35px;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: normal;
    text-transform: uppercase;
    color: #0084FF;
    background-color: #d8e1e9;
    box-sizing: border-box;
    outline: none;
    border: none;
    cursor: pointer;
  }

  @media (max-width: 1040px) {
    .print-button {
      width: 50%;
    }
  }
</style>
